export default __webpack_public_path__ + "static/media/shelf (summer 2011).6f31bb35.JPG";